import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import compose from 'recompose/compose';
import { authorized } from '../containers/Authorization';
import GraphQLLoader from '../components/GraphQLLoader';
import GraphQLError from '../components/GraphQLError';

const CommunityProfileIdQuery = gql`
  query communityProfile {
    viewer {
      id
      isNavianceLogin
      profile {
        communityId
      }
    }
  }
`;

const withCommunityProfileIdQuery = compose(
  authorized(),
  graphql(CommunityProfileIdQuery, { name: 'communityProfile' }),
  GraphQLLoader,
  GraphQLError,
);

const PRIVATE = 'PRIVATE';
const getCommunityPersonPhone = (contact) => {
  const { field_office_phone_privacy: officePhonePrivacy, field_office_phone: officePhone,
    field_mobile_phone_privacy: mobilePhonePrivacy, field_mobile_phone: mobilePhone } = contact;
  let phone;

  if (officePhone !== null && officePhonePrivacy !== PRIVATE) {
    phone = officePhone;
  } else if (mobilePhone !== null && mobilePhonePrivacy !== PRIVATE) {
    phone = mobilePhone;
  } else {
    phone = '';
  }
  return phone;
};
export { getCommunityPersonPhone as default, withCommunityProfileIdQuery };
